import { times } from "lodash/fp";

import { Skeleton } from "@mui/material";

import Stack from "@rui/Stack";

const LoadingTable = () => (
  <Stack spacing={1} sx={{ p: 1 }}>
    {times(
      (i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          height={50}
          sx={{ borderRadius: "8px" }}
        />
      ),
      3
    )}
  </Stack>
);
export default LoadingTable;
